import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { listProducts } from '../Api'

export default generateApiAction({
  baseType: Types.PRODUCTS.LIST,
  api: listProducts,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/products/ListAction.js